import {
  jb_e_service_icon_css_default
} from "./chunk.LTDECMG3.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.RCJUEYAG.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-e-service-icon/jb-e-service-icon.ts
var JbEServiceIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="shackleMask">
          <rect
            x="0"
            y="-5"
            width="25"
            height="30"
            fill="white"
          />
          <rect
            x="13"
            y="8.1"
            width="5"
            height="10"
            fill="black"
          />
        </mask>
        <g mask="url(#shackleMask)">
          <rect
            x="2.6"
            y="7.6"
            width="18.8"
            height="15.8"
            rx="2.4"
            stroke="currentColor"
            stroke-width="1.2"
          />
          <path
            id="shackle"
            d="M16.4153 10.57579V6.30884C16.4153 5.05702 16.028 3.85648 15.2 2.97131C14.372 2.08615 13.1711 1.58887 12.0001 1.58887C10.8291 1.58887 9.625 2.08615 8.797 2.97131C7.96899 3.85648 7.58496 5.05702 7.58496 6.30884V7.57579"
            stroke="currentColor"
            stroke-width="1.2"
          />
        </g>
      </svg>
      <slot></slot>
    `;
  }
};
JbEServiceIcon.styles = [reset_css_default, jb_e_service_icon_css_default];
JbEServiceIcon = __decorateClass([
  customElement("jb-e-service-icon")
], JbEServiceIcon);

export {
  JbEServiceIcon
};
